import Vue from 'vue';
import VueRouter from 'vue-router';

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return routerPush
        .call(this, location)
        .catch((error) => {
        });
};

import authRoutes from './modules/auth';
import quotationRoutes from './modules/quotations';
import leadRoutes from './modules/leads';
import calculatorRoutes from './modules/calculators';
import generalRoutes from './modules/general';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    linkActiveClass: "",
    linkExactActiveClass: "",
    scrollBehavior: () => ({y: 0}),
    routes: [
        ...authRoutes,
        {
            path: '/',
            redirect: '/home',
            name: 'Home',
            component: require('./../containers/Master').default,
            meta: {
                breadcrumb: 'Home'
            },
            children: [
                // ...quotationRoutes,
                // ...leadRoutes,
                // ...calculatorRoutes,
                ...generalRoutes,
            ]
        },
        {
            path: '*',
            name: '404',
            component: require('./../views/Errors/Page404').default,
        }
    ],
});

import store from './../store';

router.beforeEach((to, from, next) => {
    store.dispatch('table/clearEverything');
    store.dispatch('application/resetTopBar');
    next();
});

export default router;
